module.exports = __webpack_public_path__ + "img/boot_portkey.ce93850e.jpg";